import { AbstractControl } from "@angular/forms";

export function IsObject(control: AbstractControl) {
    return typeof control.value === 'object' ? null : { isObject: true };
}

export function EmailValidator(control: AbstractControl) {
    return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(control.value))  ? null : { email: true };
}

export function DateValidator(control: AbstractControl) {
    const date = new Date(control.value);
    return (date instanceof Date && !isNaN(date.valueOf())) ? null : { date: true };
}


// WEBPACK FOOTER //
// ./src/app/utils.ts